/**
 * The WhatSub methods keep track of subscriptions to events
 * Users can create subscriptions using the `subscribe` function
 * By using `dispatch`, an event can be triggered and all subscription callbacks will be triggered
 * Lastly, you can remove a subscription from the list by using the `unsubscribe` function
 *
 * @example
 * subscribe('TEST_EVENT', testFn);
 * dispatch('TEST_EVENT', ['something', 'else']);
 * unsubscribe('TEST_EVENT', testFn);
 */

const subscribers = {};
export default function WhatsSub() {}

/**
 * Subscribe to a new event
 * @param {String} event
 * @param {Function} callback
 * @param {int} priority
 *
 * @return {void}
 */
export const subscribe = (event, callback, priority = 0) => {
    if (!subscribers[event]) {
        subscribers[event] = [];
    }

    subscribers[event].push({
        callback,
        priority,
    });
};

/**
 * Trigger all required actions based on an event
 * @param {String} event
 * @param {Object} target
 *
 * @return {void}
 */
export const dispatch = (event, target) => {
    let targets = target;
    if (!Array.isArray(target)) {
        targets = [target];
    }

    if (subscribers[event]) {
        subscribers[event].forEach((subscriber) => {
            subscriber.callback.apply(null, targets);
        });
    }
};

/**
 * Unsubscribe from an event
 * @param {String} event
 * @param {Function} callback
 *
 * @return {void}
 */
export const unsubscribe = (event, callback) => {
    if (subscribers[event]) {
        subscribers[event] = subscribers[event].filter((subscriber) => subscriber.callback !== callback);
    }
};

/**
 * Show a list of all the subscriptions
 *
 * @return {Object}
 */
export const getSubscribers = () => subscribers;

/**
 * Show of a list of all the subscriptions by event
 *
 * @param {String} event
 *
 * @return {Object}
 */
export const getSubscribersByEvent = (event) => subscribers[event];



// WEBPACK FOOTER //
// ./src/js/modules/Whatsub.js